import React, { useState, useEffect } from 'react';
import { faFileAlt, faFileImage, faPencilAlt, faSave, faCheck, faExclamation, faExclamationTriangle, faClose, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import ModalCustomized from '../../components/Modal/Modal';
import TextField from '../../components/TextField/TextField';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import AutoDeInfracaoImpressao from '../../views/Shared/AutoDeInfracaoImpressao';

//Api
import notificacao_api from '../../api/notificacao_api';
import tipoAutoInfracao_api from '../../api/tipoAutoInfracao_api';
import autoInfracao_api from '../../api/autoInfracao_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from '../../helpers/cookies';
import uuid from '../../helpers/guid';

//Context
import { useAuth } from 'context/auth';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

function initialStateJustificativa(tbNotificacao_id) {
    return {
        tbNotificacao_id: tbNotificacao_id,
        dataHora: "",
        observacoes: "",
        status: "Aguardando Análise",
        anexo: "",
        anexoBase64: "",
    }
}

export default function FichaNotificacao({ id, btnVoltar }) {
    const { setLoading } = useAuth();

    //Variavel com os dados do usuario logado
    const usuario = getSessionCookie();

    //Estado de controle de visibilidade do modal
    const [openModal, setOpenModal] = useState(false);

    //Função que faz a troca de visibilidade do modal
    const toggleModal = () => setOpenModal(prev => !prev);

    //Estado de controle de visibilidade do modal
    const [openModalAutoInfracao, setOpenModalAutoInfracao] = useState(false);

    //Função que faz a troca de visibilidade do modal
    const toggleModalAutoInfracao = () => setOpenModalAutoInfracao(prev => !prev);

    //Estado para pegar a lista de tipo de infracoes
    const [listTipoAutoInfracoes, setListTipoAutoInfracoes] = useState([]);

    //Estado para visualizar ficha de auto de infração
    const [visualizarAutoInfracao, setVisualizarAutoInfracao] = useState(null);

    //Estado de controle dos dados da notificação buscada
    const [notificacao, setNotificacao] = useState({});

    //Estado de controle dos dados da notificação buscada
    const [autoInfracao, setAutoInfracao] = useState({
        tbNotificacao_Id: "",
        tbTipoAutoInfracao_Id: "",
        categoria: ""
    });

    //Estado inicial da justificativa
    const [justificativa, setJustificativa] = useState(initialStateJustificativa(id));

    //Estado de controle de erros na justificativa
    const [errorsJustificativa, setErrorsJustificativa] = useState({});

    //Estado de controle da ação executada ao clicar em um dos botões
    const [titleModal, setTitleModal] = useState("+ Justificar");

    //Carregando os dados da notificacao
    const loadNotificacao = () => {
        setLoading(true);
        notificacao_api.GetItem(id).then(response => {
            if (response.data.justificativas) {
                response.data.justificativas = response.data.justificativas.map(value => {
                    value.dataHora = moment(new Date(value.dataHora)).format("DD/MM/YYYY HH:mm");
                    return value;
                });
            }
            response.data.respostasJustificativa = response.data.respostasJustificativa.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setNotificacao(response.data);
        }).catch(e => {
            showMessage("Aviso!", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    async function loadTipoAutoInfracoes() {
        try {
            setLoading(true);
            const { data } = await tipoAutoInfracao_api.GetListByCategoria(notificacao?.categoria);
            setListTipoAutoInfracoes(data);
        } catch (error) {
            showMessage("Error", error.message, "error", null);
        }finally{
            setLoading(false);
        }
    }

    //Cabeçalhos da tabela de notificações
    const headers = [
        { value: "Fato Constitutivo", objectValue: "fatoConstitutivo" },
        { value: "Preceitos Legais", objectValue: "preceitosLegais" },
        { value: "Status", objectValue: "status" },
        { value: "Valor Multa", objectValue: "valorMulta" } 
    ];

    function handleSelectTipoAutoInfracao(rowData) {
        setAutoInfracao({
            ...autoInfracao,
            tbNotificacao_Id: notificacao.id,
            tbTipoAutoInfracao_Id: rowData.id,
            categoria: notificacao.categoria
        }) 
    }

    const actions = [ actionsTable.confirmar(handleSelectTipoAutoInfracao)  ]

    useEffect(() => {
        loadNotificacao();
    }, []); 

    //Função que realiza o cadastro da justificativa
    const enviarAcao = () => {
        switch (titleModal) {
            case "+ Justificar":
                cadastrarJustificativa();
                break;
            case "Baixar sem justificativa":
            case "Aprovar justificativa":
            case "Reprovar justificativa":
            case "Confirmar notificação":
                enviarDadosFiscal();
                break;
            default: 
                break;
        } 
    }

     //Função que realiza o cadastro da justificativa
    async function onSubmitAutoInfracao() {
       try {
            if (autoInfracao.tbTipoAutoInfracao_Id.length === 0)
                return showMessage("Aviso", "Por favor, Selecione um tipo de infração.", "warning", null);

            setLoading(true);
            const { data } = await autoInfracao_api.Insert(autoInfracao);
            if(data) {
                showMessage("Sucesso", "Sucesso ao criar auto de infração", "success", () => {
                    toggleModalAutoInfracao();
                    setAutoInfracao({
                        categoria: "",
                        tbNotificacao_Id: "",
                        tbTipoAutoInfracao_Id: ""
                    });
                    loadNotificacao();
                });
            }
        } catch (error) {
            showMessage("Error", error.message, "error", null);
        }finally{
            setLoading(false);
        } 
    }

    //função que realiza o cadastro da justificativa
    const cadastrarJustificativa = () => {
        if (!justificativa.observacoes || !justificativa.tbTipoNotificacaoJustificativa_Id) {
            setErrorsJustificativa({ observacoes: !justificativa.observacoes ? "Campo vazio" : null, tbTipoNotificacaoJustificativa_Id: !justificativa.tbTipoNotificacaoJustificativa_Id ? "Campo vazio" : null });
            return;
        }

        const _justificativa = { ...justificativa };
        _justificativa.dataHora = moment(new Date()).format("YYYY-MM-DD HH:mm");

        setLoading(true);
        notificacao_api.SalvarJustificativa(_justificativa).then(response => {
            showMessage("Sucesso", "Justificativa salva com sucesso!", "success", null);
            setJustificativa(initialStateJustificativa(id));
            loadNotificacao();
            toggleModal();
            setErrorsJustificativa({});
        }).catch(e => {
            showMessage("Aviso!", e.message, "error")
        }).finally(f => setLoading(false));
    }

    //Função de atualização dos dados da justificativa pelo fiscal
    const enviarDadosFiscal = () => {
        if (!justificativa.observacoes) {
            setErrorsJustificativa({ observacoes: "Campo vazio" });
            return;
        }
        const _justificativa = {
            ...!!notificacao.justificativas ? notificacao.justificativas[0] : {},
            dataHoraAnalise: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            observacoesFiscal: justificativa.observacoes,
            tbNotificacao_id: id
        };

        switch (titleModal) {
            case "Baixar sem justificativa":
                _justificativa.status = "Baixado sem justificativa";
                break;
            case "Confirmar notificação":
                _justificativa.status = "Notificação confirmada sem justificativa";
                break;
            case "Aprovar justificativa":
                _justificativa.status = "Analisado e Aceitado";
                break;
            case "Reprovar justificativa":
                _justificativa.status = "Analisado e Recusado";
                break;
            default: 
                break;
        }

        if (_justificativa.status === "Baixado sem justificativa") {
            _justificativa.dataHora = moment(new Date()).format("YYYY-MM-DD HH:mm");
        } else {
            delete _justificativa.dataHora;
        }
        setLoading(true);
        notificacao_api.AtualizarJustificativaFiscal(_justificativa).then(response => {
            showMessage("Sucesso!", "Justificativa analisada com sucesso!", "success", null);
            setJustificativa(initialStateJustificativa(id));
            loadNotificacao();
            toggleModal();
        }).catch(e => showMessage("Aviso!", e.message, "error", null))
            .finally(f => setLoading(false));

    }

    //Função que faz o controle do onChange da justificativa
    const onChangeJustificativa = (e) => {
        const { name, value } = e.target;
        setJustificativa({
            ...justificativa,
            [name]: value
        })
    }

    //Função de onChange do select
    const onChangeTipoJustificativa = (e, select) => {
        const { name } = select;
        setJustificativa({
            ...justificativa,
            [name]: e.value
        });
    } 

    //Função de controle de exibição do botão de ação 1
    const BtnAction1 = () => {
        if (usuario.acesso.sigla == "FS" && !!notificacao) {
            if (notificacao.status == "Aguardando Justificativa")
                return (<Button onClick={() => {
                    setTitleModal("Baixar sem justificativa");
                    toggleModal();
                }} color='success'><FontAwesomeIcon icon={faCheck} /> Baixar sem justificativa</Button>)
            else if (notificacao.status == "Aguardando Análise")
                return (<Button onClick={() => {
                    setTitleModal("Aprovar justificativa");
                    toggleModal();
                }} color='success'><FontAwesomeIcon icon={faCheck} /> Aprovar</Button>)

        }
        return null;
    }

    const BtnAction2 = () => {
        if (usuario.acesso.sigla == "FS" && !!notificacao) {
            if (notificacao.status == "Aguardando Análise") {
                return (<Button onClick={() => {
                    setTitleModal("Reprovar justificativa");
                    toggleModal();
                }} className='ms-3 text-white' color='warning'><span className="fw-bold ">X</span> Reprovar</Button>)
            } else if (notificacao.status == "Aguardando Justificativa" && (new Date()).getTime() > (new Date(notificacao.prazoJustificativa)).getTime()) {
                return (<Button 
                    onClick={() => {
                    setTitleModal("Confirmar notificação");
                    toggleModal();
                }} className='ms-3' color='danger'><span className="fw-bold">X</span> Confirmar Notificação</Button>)
            }
        }
        return null;

    }

    const BtnAction3 = () => {
        if (usuario.acesso.sigla == "FS" && !!notificacao) {
            if (notificacao.status == "Aguardando Análise") {
                return (
                    <Button 
                        onClick={() => {
                          loadTipoAutoInfracoes();
                          toggleModalAutoInfracao();
                        }} 
                        className='ms-3 text-white'
                        color='danger'
                    >
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span className='ms-1'>Gerar Auto Infração</span>
                    </Button> )
            }
            if(notificacao.status === "Gerado Auto Infração"){
                return (
                    <Button 
                        onClick={() => { setVisualizarAutoInfracao(notificacao.autoInfracao)}} 
                        className='ms-3 text-white'
                        color='primary'
                    >
                        <FontAwesomeIcon icon={faSearch} />
                        <span className='ms-1'>Visualizar Auto Infração</span>
                    </Button> )
            }
        }
        return null; 
    }


    //Change do anexo da justificativa
    const onChangeAnexo = (e) => {
        if (!e.target.files || !e.target.files[0]) {
            setJustificativa({
                ...justificativa,
                anexo: "",
                anexoBase64: "",
            });
            return;
        }

        if (e?.target?.files[0]?.type.startsWith("image/")) {
            const FR = new FileReader();

            FR.addEventListener("load", function (evt) {
                let base64 = evt.target.result;
                setJustificativa({
                    ...justificativa,
                    anexo: uuid() + ".png",
                    anexoBase64: base64.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "")
                })
            });

            FR.readAsDataURL(e.target.files[0]);
        } else {
            showMessage("Aviso", "Apenas arquivos de imagem no formato PNG ou JPEG são permitidos. Por favor, selecione um arquivo válido.", "warning", null);
            return
        }
    }

    return (
        <>
        {!!visualizarAutoInfracao &&
            <AutoDeInfracaoImpressao hash={visualizarAutoInfracao.uuid} handleReturn={() => { setVisualizarAutoInfracao(null) }}/>
        }
        {!visualizarAutoInfracao && 
            <MainCard
                btnVoltar={btnVoltar}
                btnCadastro={usuario.acesso.sigla !== "FS" && notificacao && notificacao.status == "Aguardando Justificativa" ? "Justificar" : null}
                onClickBtnCadastro={toggleModal}
                BtnAction1={usuario.acesso.sigla ==="FS" ? BtnAction1 : null}
                BtnAction2={usuario.acesso.sigla ==="FS" ? BtnAction2 : null}
                BtnAction3={usuario.acesso.sigla ==="FS" ? BtnAction3 : null}
            >
                <div style={{ color: "#666" }}> 
                    <ModalCustomized isOpen={openModal} toggle={toggleModal} title={titleModal} btnClose={toggleModal}>
                        <Row>
                            <Col>
                                {titleModal == "+ Justificar" &&
                                    <TextField
                                        label={"* Tipo da justificativa"}
                                        type={"select"}
                                        options={notificacao.respostasJustificativa}
                                        searchable
                                        onChange={onChangeTipoJustificativa}
                                        name="tbTipoNotificacaoJustificativa_Id"
                                        invalid={errorsJustificativa.tbTipoNotificacaoJustificativa_Id}
                                        value={notificacao.respostasJustificativa && notificacao.respostasJustificativa.filter(v => v.value == justificativa.tbTipoNotificacaoJustificativa_Id)} />
                                }
                                <TextField
                                    label={"* Justificativa"}
                                    type={"textarea"}
                                    name="observacoes"
                                    invalid={errorsJustificativa.observacoes}
                                    onChange={onChangeJustificativa}
                                    value={justificativa.observacoes} />
                                {titleModal == "+ Justificar" &&
                                    <>

                                        <TextField
                                            label={"Anexo"}
                                            type={"file"}
                                            onChange={onChangeAnexo}
                                            name="anexo"
                                            accept="image/png,image/jpeg" />
                                        {justificativa.anexoBase64 &&
                                            <Col md={"12"} lg={"12"} className="text-center mb-3">
                                                <img width={"300px"} id="anexo_justificativa" src={"data:image/png;base64," + justificativa.anexoBase64}></img>
                                            </Col>
                                        }
                                    </>
                                }
                            </Col>
                        </Row>
                        <div className='d-flex align-items-center justify-content-center'>
                            <Button color='success' onClick={enviarAcao}>
                                <FontAwesomeIcon icon={faSave} /> Salvar
                            </Button>
                        </div>
                    </ModalCustomized>

                    {/* Modal para selecionar auto de infração                */}
                    <ModalCustomized 
                        isOpen={openModalAutoInfracao} 
                        toggle={toggleModalAutoInfracao} 
                        title={"Selecione o tipo da infração"} 
                        btnClose={toggleModalAutoInfracao}
                    >
                        <Row>
                            {!!autoInfracao.tbTipoAutoInfracao_Id &&
                                <Col lg={12} md={12} style={{color: "#4c4b4b"}}>
                                    {(() => {
                                        const tipoSelecionado = listTipoAutoInfracoes.find(
                                            (tipo) => tipo.id === autoInfracao.tbTipoAutoInfracao_Id
                                        );
                                        
                                        if (!tipoSelecionado) return null;

                                        return (
                                            <div className="p-3 mb-3 border rounded bg-light">
                                                <h5 className="mb-3">Detalhes do Tipo de Infração Selecionado</h5>
                                                <p><strong>Fato Constitutivo:</strong> {tipoSelecionado.fatoConstitutivo}</p>
                                                <p><strong>Preceitos Legais:</strong> {tipoSelecionado.preceitosLegais}</p>
                                                <p>
                                                    <strong>Valor da Multa:</strong>{" "}
                                                    {tipoSelecionado.valorMulta.toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL'
                                                    })}
                                                </p>
                                            </div>
                                        );
                                    })()}
                                </Col>
                            }
                            <Col lg={12} md={12}>
                                <TabelaListagem 
                                    items={listTipoAutoInfracoes.map((value) => {
                                        value.valorMulta = value.valorMulta.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        });
                                        return value;
                                    })} 
                                    headers={headers} 
                                    actions={actions} 
                                />
                            </Col>
                        </Row>
                        <div className='d-flex align-items-center justify-content-center gap-3'>
                            <Button color='danger' onClick={() => {
                                toggleModalAutoInfracao();
                            }}>
                                <FontAwesomeIcon icon={faClose} /> Cancelar
                            </Button>
                            <Button color='success' onClick={onSubmitAutoInfracao}>
                                <FontAwesomeIcon icon={faSave} /> Confirmar
                            </Button>
                        </div>
                    </ModalCustomized>

                    <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Detalhes da notificação</h5>
                    <Row>
                        <Col md="12" lg="12">
                            <p><span className="fw-bold">Tipo da notificação:</span> {notificacao?.tbTipoNotificacao_descricao}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Data/Hora da notificação:</span> {moment(notificacao?.dataHora).format("DD/MM/YYYY HH:mm")}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Prazo da justificativa:</span> {moment(notificacao?.prazoJustificativa).format("DD/MM/YYYY HH:mm")}</p>
                        </Col>
                        {usuario.acesso.sigla == "FS" &&
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Fiscal:</span> {notificacao?.nomeFiscal}</p>
                            </Col>
                        }
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Status:</span> {notificacao?.status}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Nome do {notificacao?.categoria ?? "usuário"}:</span> {notificacao?.identificacao}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">CPF/CNPJ:</span> {notificacao?.cnpj}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Email:</span> {notificacao?.email}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Telefone:</span> {notificacao?.telefone}</p>
                        </Col>
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Enderenço:</span> {notificacao?.enderenco}</p>
                        </Col>
                        {notificacao?.modalidade &&
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Modalidade:</span> {notificacao?.modalidade}</p>
                            </Col>
                        }
                        {notificacao?.localidade &&
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Localidade:</span> {notificacao?.localidade}</p>
                            </Col>
                        }
                    </Row>
                    <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faFileImage} className="me-2" /> Anexos</h5>
                    <Row>

                        {notificacao.imagens && notificacao.imagens.map(value => {

                            return (
                                <Col md={"12"} lg={"4"} className={"mb-3 mt-3"}>
                                    <img src={value.nomeArquivo} width="200px" height="300px" />
                                </Col>
                            )
                        })}
                    </Row>
                    {
                        (notificacao.status != "Baixado sem justificativa" && notificacao.status != "Notificação confirmada sem justificativa") && notificacao.justificativas && notificacao.justificativas.length > 0
                            ?
                            <>
                                <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faFileAlt} className="me-2" /> Justificativa</h5>
                                <p><span className="fw-bold">Usuário:</span> {notificacao.justificativas[0].nomeUsuario}</p>
                                <p><span className="fw-bold">Tipo de justificativa:</span> {notificacao.justificativas[0].tipoJustificativa}</p>
                                <p><span className="fw-bold">Justificativa:</span> {notificacao.justificativas[0].observacoes}</p>
                                {notificacao.justificativas[0].anexo &&
                                    <Col md={"12"} lg={"12"} className=" mb-3">
                                        <img width={"300px"} id="anexo_justificativa" src={notificacao.justificativas[0].anexo}></img>
                                    </Col>
                                }
                            </>
                            : <></>
                    }
                    {
                        notificacao.status != "Aguardando Justificativa" && notificacao.status != "Aguardando Análise" && notificacao.justificativas
                            ?
                            <>
                                <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faFileAlt} className="me-2" /> Analise do fiscal</h5>
                                <p><span className="fw-bold">Fiscal:</span> {notificacao.justificativas[0].nomeFiscal}</p>
                                <p><span className="fw-bold">Justificativa:</span> {notificacao.justificativas[0].observacoesFiscal}</p>
                            </>
                            : <></>
                    }
                </div>
            </MainCard>
        }
        </>
    )
}